<template>
  <v-card tile flat>
    <v-card-title>
      <v-text-field
        v-bind:value="filter"
        v-on:input="applyFilter"
        prepend-inner-icon="mdi-magnify"
        label="Filtra"
        clearable
        flat
        hide-details
        autofocus
        dense
      />
      <v-spacer />
      <v-btn v-on:click="newCustomer" class="primary mr-2">Nuovo cliente</v-btn>
      <v-btn v-on:click="importCustomers = true" class="primary">Importa clienti</v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table
        v-bind:headers="headers"
        v-bind:options.sync="options"
        v-bind:items="rows"
        v-bind:server-items-length="totalRows"
        v-bind:loading="server_loading"
        v-bind:footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
        v-on:click:row="editCustomer"
        calculate-widths
      >
        <template v-slot:item.name="{ item }">
          <v-icon v-if="item.active === '0'" class="mr-1 grey--text" small>mdi-eye-off</v-icon>
          <span v-bind:class="{ 'grey--text': item.active === '0' }">{{ item.name }}</span>
        </template>

        <template v-slot:item.gender="{ item }">
          {{ genderByValue[item.gender] }}
        </template>

        <template v-slot:item.address="{ item }">
          <span v-if="item.address">{{ item.address }} - </span>
          <span v-if="item.zip_code">{{ item.zip_code }} &nbsp;</span>
          <span v-if="item.city">{{ item.city }} &nbsp;</span>
          <span v-if="item.province">({{ item.province }})</span>
        </template>

        <template v-slot:item.contacts="{ item }">
          <div class="ma-0" v-for="(contact, index) in contacts_load(item.contacts)" v-bind:key="index">
            <v-icon small>{{ contact.icon }}</v-icon>
            <span class="ml-1">{{ contact.value }}</span>
          </div>
        </template>
      </v-data-table>
    </v-card-text>

    <customer-details v-model="selectedCustomer" />
    <import-customers v-model="importCustomers" />
  </v-card>
</template>

<script>
import server from '../mixins/server'
import utils from '../mixins/utils'
import contacts from '../mixins/contacts'
import CustomerDetails from '../components/CustomerDetails'
import ImportCustomers from '../components/ImportCustomers'

export default {
  name: 'Customers',

  mixins: [ server, utils, contacts ],

  components: { CustomerDetails, ImportCustomers },

  data: () => ({
    headers: [
      { text: 'Nome', value: 'name', width: '25%' },
      { text: 'Sesso', value: 'gender', width: '25%' },
      { text: 'Indirizzo', value: 'address', width: '25%' },
      { text: 'Contatti', value: 'contacts', width: '25%' },
    ],
    filter: '',
    totalRows: 0,
    rows: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['name'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
    selectedCustomer: {},
    importCustomers: false,
    genderByValue: {
      'F': 'Femmina',
      'M': 'Maschio',
      'A': 'Altro',
    },
  }),

  watch: {
    options: {
      handler () { this.loadRows(); },
      deep: true,
    },
    selectedCustomer: {
      handler (newValue) { if ('newId' in newValue) this.loadRows(); },
    }
  },

  methods: {
    applyFilter: function(value) {
      this.filter = value;

      // When appling the filter we move to first page and this
      // forces the reload of the rows
      this.utils_delayExecute((this.options.page != 1) ? this.loadFirstPage : this.loadRows);
    },

    loadFirstPage: function() {
      this.options.page = 1;
    },

    loadRows: function() {
      const parameters = {};

      parameters['page'] = this.options.page;
      parameters['rows'] = this.options.itemsPerPage;

      // Add filter
      if (this.filter) {
        parameters['filter'] = this.filter;
      }

      // Add sorting
      if (this.options.sortBy.length > 0) {
        parameters['order'] = this.options.sortBy[0];
        if (this.options.sortDesc[0]) {
          parameters['order'] = '-' + parameters['order'];
        }
      }

      this.server_query({
        url: 'Customer/list',
        parameters: parameters,
        onError: () => {
          this.rows = [];
          this.totalRows = 0;
        },
        onSuccess: (data) => {
          this.rows = data.rows;
          this.totalRows = data.total;
        },
      });
    },

    newCustomer: function() { this.selectedCustomer = { id: 0, active: '1' }; },

    editCustomer: function(item) { this.selectedCustomer = Object.assign({}, item); },
  }
}
</script>
